<div class="input-container"
    [style.height]="multiline ? '100%' : null"
    [style.borderColor]="showErrorBorder && errorList?.length > 0 ? null : (overrideBorderColor ? overrideBorderColor : null)"
    [class.has-error]="showErrorBorder && errorList?.length > 0"
    [class.is-disabled]="isDisabled"
    [class.is-readonly]="isReadonly">

    <p-multiSelect
        (onFocus)="focus($event)"
        (onBlur)="blur($event)"
        (mouseenter)="mouseEnter($event)"
        (mouseleave)="mouseLeave($event)"
        [options]="options"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        display="chip"
        class="select-chips"
        [showClear]="showClear"
        [overlayOptions]="overlayOptions"
        [showHeader]="false"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [ngClass]="customClasses"
        [maxSelectedLabels]="maxSelectedLabels"
        [tabindex]="tabIndex"
        [attr.tabindex]="tabIndex"
        [class.is-multiline]="multiline ? multiline : null"
        #popperError="popper"
        popperAppendTo="body"
        [panelStyleClass]="panelClass"
        [popper]="tooltipErrTemplate"
        [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
        [popperTrigger]="ngxPopperjsTriggers.hover"
        [popperPlacement]="ngxPopperjsPlacements.TOP"
        [popperPreventOverflow]="false"
        [popperHideOnScroll]="true"
        [appendTo]="appendTo"
        popperApplyClass="error"
        [class.has-commands]="customCommandList?.length > 0">
    </p-multiSelect>

    <div class="command-list-container"
        *ngIf="customCommandList?.length > 0"
        [class.is-disabled]="isDisabled">
        <ng-template ngFor let-command [ngForOf]="customCommandList">
            <nts-ribbon-button [title]="command.tooltip"
                [tabIndex]="0"
                [isLoading]="command.loading$ | async"
                [icon]="command.iconClass"
                [isDisabled]="!(command.canExecute$ | async)"
                (onClicked)="command.execute()">
            </nts-ribbon-button>
        </ng-template>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>